<template>
  <div class="modal">
    <div class="modal-content">
      <h2>🕘 Registrar Marcación</h2>

      <!-- Vista previa -->
      <div class="preview">
        <video v-if="!fotoTomada" ref="video" autoplay muted></video>
        <img v-if="fotoTomada" :src="fotoBase64" alt="Foto capturada"/>
      </div>

      <div class="boton-foto">
        <button @click="capturarFoto" aria-label="Capturar foto">📸 Capturar Foto</button>
      </div>

      <!-- Ubicación -->
      <p>
        📍 <strong>Ubicación:</strong>
        <span v-if="latitud && longitud">{{ latitud }}, {{ longitud }}</span>
        <span v-else style="color: #999;">Ubicación no disponible</span>
      </p>
      <button @click="obtenerUbicacion" aria-label="Actualizar ubicación">🔄 Actualizar Ubicación</button>

      <!-- Tipo de marcación -->
      <p>
        📝<strong>Tipo de marcación:</strong>
      </p>

      <div class="tipo-botones">
        <button @click="cambiarTipo('entrada')" :class="tipo === 'entrada' ? 'activo' : ''">Entrada</button>
        <button @click="cambiarTipo('salida')" :class="tipo === 'salida' ? 'activo' : ''">Salida</button>
      </div>

      <p>📅 <strong>Fecha:</strong> {{ fecha }}</p>
      <p>⏰ <strong>Hora:</strong> {{ hora }}</p>

      <a-form :form="form" v-if="this.camposAdicionales === 'SI'">
        <a-row :gutter="[12,12]" v-if="tipo === 'entrada'">
          <a-col v-bind="colOptions">
            <g-dropdown
              :label="$t('Placa-Proyecto')"
              endpoint="hierarchy_lookup"
              :params="placaProyectoParams"
              placeholder="Seleccione vehículo o proyecto"
              :formItemConfig="fiOptions"
              :decorator="['license_plate_or_project', { rules: [{ required: true, message: 'Valor requerido' }] }]"
            />
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item :label="$t('Lugar de Salida')" v-bind="fiOptions">
              <a-input
                style="width: 100%"
                placeholder="Ejemplo: Calle 123, Ciudad"
                v-decorator="['place_of_departure', { rules: [{ required: false, message: 'Valor requerido' }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item :label="$t('Kilometraje Inicial')" v-bind="fiOptions">
              <a-input-number
                style="width: 100%"
                :min="1"
                :max="999999"
                :parser="digitsOnly"
                v-decorator="['initial_mileage', { rules: [{ required: false, message: 'Valor requerido' }, { validator: validateKilometraje }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item :label="$t('Descripción Primer Recorrido')" v-bind="fiOptions">
              <a-textarea
                style="width: 100%"
                autoSize
                placeholder="Origen - Destino"
                v-decorator="['description_route', { rules: [{ required: false, message: 'Valor requerido' }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item :label="$t('Descripción Segundo Recorrido')" v-bind="fiOptions">
              <a-textarea
                style="width: 100%"
                autoSize
                placeholder="Origen - Destino"
                v-decorator="['description_route2', { rules: [{ required: false, message: 'Valor requerido' }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item :label="$t('Descripción Tercer Recorrido')" v-bind="fiOptions">
              <a-textarea
                style="width: 100%"
                autoSize
                placeholder="Origen - Destino"
                v-decorator="['description_route3', { rules: [{ required: false, message: 'Valor requerido' }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item :label="$t('Descripción Cuarto Recorrido')" v-bind="fiOptions">
              <a-textarea
                style="width: 100%"
                autoSize
                placeholder="Origen - Destino"
                v-decorator="['description_route4', { rules: [{ required: false, message: 'Valor requerido' }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item :label="$t('Descripción Quinto Recorrido')" v-bind="fiOptions">
              <a-textarea
                style="width: 100%"
                autoSize
                placeholder="Origen - Destino"
                v-decorator="['description_route5', { rules: [{ required: false, message: 'Valor requerido' }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item :label="$t('Descripción Sexto Recorrido')" v-bind="fiOptions">
              <a-textarea
                style="width: 100%"
                autoSize
                placeholder="Origen - Destino"
                v-decorator="['description_route6', { rules: [{ required: false, message: 'Valor requerido' }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <g-dropdown
              :label="$t('Nombre Cliente')"
              endpoint="hierarchy_lookup"
              :params="clienteParams"
              placeholder="Seleccione cliente"
              :formItemConfig="fiOptions"
              :decorator="['client_name', { rules: [{ required: false, message: 'Valor requerido' }] }]"
            />
          </a-col>
        </a-row>

        <a-row :gutter="[12,12]" v-if="tipo === 'salida'">
<!--          <a-col v-bind="{xs: 24, sm: 24}">
            <a-form-item :label="$t('¿Realiza otro recorrido?. Si es asi, indique cual')"
                         v-bind="fiOptions">
              <a-textarea
                style="width: 100%"
                autoSize
                placeholder="Si, ¿cuál?"
                v-decorator="['make_another_tour', { rules: [{ required: false, message: 'Valor requerido' }] }]"
              />
            </a-form-item>
          </a-col>
           <a-col v-bind="colOptions">
            <a-form-item :label="$t('Hora Final del servicio')" v-bind="fiOptions">
              <a-time-picker
                style="width: 100%"
                format="HH:mm"
                valueFormat="HH:mm"
                v-decorator="['end_time', { rules: [{ required: false, message: 'Valor requerido' }] }]"
              />
            </a-form-item>
          </a-col> -->
          <a-col v-bind="colOptions">
            <a-form-item :label="$t('Kilometraje Final')" v-bind="fiOptions">
              <a-input-number
                style="width: 100%"
                :min="1"
                :max="999999"
                :parser="digitsOnly"
                v-decorator="['final_mileage',{ rules: [{ required: false, message: 'Valor requerido' }, { validator: validateKilometraje }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item :label="$t('Cant. de Pasajeros Transportados')" v-bind="fiOptions">
              <a-input-number
                style="width: 100%"
                :min="0"
                :max="3"
                v-decorator="['number_passengers', { rules: [{ required: false, message: 'Valor requerido' }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item :label="$t('Hora de descanso')" v-bind="fiOptions">
              <a-time-picker style="width: 100%" format="HH:mm" valueFormat="HH:mm" v-decorator="['break_time']"/>

            </a-form-item>
            <small style="margin-top: -10px; display: block; color: #888; font-size: 12px;">
              {{ $t('Máximo una hora') }}
            </small>
          </a-col>

          <a-col v-bind="{xs: 24, sm: 24}">
            <a-form-item :label="$t('Nombre de usuarios a transportar')"
                         v-bind="fiOptions">
              <a-textarea
                style="width: 100%"
                autoSize
                placeholder=""
                v-decorator="['transport_user', { rules: [{ required: false, message: 'Valor requerido' }] }]"
              />
            </a-form-item>
          </a-col>


        </a-row>
        <a-alert type="error" :message="mensajeError" v-if="error"/>
      </a-form>


      <button @click="toggleCommentForm" aria-label="Agregar comentario" v-if="permiso_agregar_comentario">📝 Agregar
        Comentario
      </button>
      <div v-if="showCommentForm" class="comment-form">
        <label for="observation">{{$t('Observación')}}:</label>
        <input type="text" id="observation" v-model="observation" :placeholder="$t('Ingrese su observación')"
               maxlength="40"/>
        <small
          :style="{ color: observation.length >= 40 ? 'red' : '#555', marginTop: '-10px', display: 'block' }"
        >
          {{ observation.length }}/40
        </small>

        <label for="comment">{{$t('Comentario')}}:</label>
        <textarea id="comment" v-model="comment" :placeholder="$t('Ingrese su comentario')"></textarea>
      </div>

      <br>
      <p class="descripcion">
        Por favor verifica tu información antes de registrar tu marcación.
      </p>

      <div class="tipo-botones">
        <button @click="enviarMarcacion" :disabled="!puedeEnviar" aria-label="Registrar marcación">✅ Registrar
          Marcación
        </button>
        <button @click="cerrar" aria-label="Cancelar">Cancelar</button>
      </div>
    </div>
  </div>
</template>

<script>
  import HttpUtil from '@/util/HttpUtil'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'

  export default {
    props: ['mostrar'],
    data () {
      return {
        permiso_agregar_comentario: this.$userIsInrol('IngresarComentMarcacionGeo'),
        video: null,
        fotoBase64: '',
        fotoTomada: false,
        tipo: '',
        latitud: '',
        longitud: '',
        fecha: '',
        hora: '',
        cantidadMarcacionesHoy: 0,
        camposAdicionales: 'NO',
        cargandoMarcaciones: true,
        observation: '',
        comment: '',
        showCommentForm: false,
        form: this.$form.createForm(this, {name: 'solicitar'}),
        colOptions: {xs: 24, sm: 12},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {span: 24},
          'has-feedback': true
        },
        placaProyectoParams: {h_lookup_type: 'PLACA_PROYECTO_GEO_MAR'},
        clienteParams: {h_lookup_type: 'CLIENTE_GEO_MAR'},
        mensajeError: '',
        error: false
      }
    },
    mounted () {
      this.httpClient = new HttpUtil()
      this.iniciarCamara()

      const ahora = new Date()
      this.fecha = ahora.toISOString().split('T')[0]
      this.hora = ahora.toLocaleTimeString()

      this.obtenerCantidadMarcacionesHoy()
      if (this.cantidadMarcacionesHoy > 4) {
        Mensajes.warning('Límite alcanzado', 'Ya tienes 4 marcaciones registradas hoy. Da clic en cancelar.')
      }
    },
    methods: {
      async obtenerCantidadMarcacionesHoy () {
        try {
          const response = await this.httpClient.getInstance().get('marcaciones_geo/count_today')
          this.cantidadMarcacionesHoy = response.data.cantidad
          this.camposAdicionales = response.data.camposAdicionales
        } catch (error) {
          Mensajes.error('Error al consultar marcaciones:', error)
        } finally {
          this.cargandoMarcaciones = false
        }
      },
      async iniciarCamara () {
        try {
          const stream = await navigator.mediaDevices.getUserMedia({video: true})
          this.video = this.$refs.video
          this.video.srcObject = stream
        } catch (error) {
          Mensajes.error('Cámara', 'No se pudo acceder a la cámara.')
        }
      },
      capturarFoto () {
        if (!this.video || !this.video.videoWidth || !this.video.videoHeight) {
          // alert('La cámara no está lista')
          Mensajes.error('Error', 'La cámara no está lista.')
          return
        }

        const canvas = document.createElement('canvas')
        canvas.width = this.video.videoWidth
        canvas.height = this.video.videoHeight
        const ctx = canvas.getContext('2d')
        ctx.drawImage(this.video, 0, 0)
        this.fotoBase64 = canvas.toDataURL('image/jpeg')
        this.fotoTomada = true
      },
      obtenerUbicacion (intentos = 0) {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(
            (pos) => {
              // eslint-disable-next-line no-unused-vars
              const accuracy = pos.coords.accuracy
              // if (accuracy <= 250) {
              this.latitud = pos.coords.latitude.toFixed(6)
              this.longitud = pos.coords.longitude.toFixed(6)
              /*              } else {
                              if (intentos < 3) {
                                // alert('La precisión de la ubicación es baja. Reintentando...')
                                Mensajes.warning('Ubicación', 'La precisión de la ubicación es baja. Reintentando...')
                                this.obtenerUbicacion(intentos + 1)
                              } else {
                                // alert('Ubicación imprecisa. Asegúrate de tener buena señal GPS.')
                                Mensajes.error('Ubicación', 'Ubicación imprecisa. Asegúrate de tener buena señal GPS.')
                              }
                            } */
            },
            (error) => {
              switch (error.code) {
                case error.PERMISSION_DENIED:
                  Mensajes.error('Permiso denegado', 'Habilita la ubicación en tu navegador.')
                  break
                case error.POSITION_UNAVAILABLE:
                  Mensajes.error('Ubicación no disponible', 'Intenta luego.')
                  break
                case error.TIMEOUT:
                  Mensajes.error('Tiempo de espera agotado', 'Intenta de nuevo.')
                  break
                default:
                  Mensajes.error('Error desconocido', 'Intenta nuevamente.')
                  break
              }
            },
            {
              enableHighAccuracy: true,
              timeout: 10000,
              maximumAge: 0
            }
          )
        } else {
          // alert('Tu navegador no soporta geolocalización.')
          Mensajes.error('Error', 'Tu navegador no soporta geolocalización.')
        }
      },
      cambiarTipo (tipo) {
        this.tipo = tipo
      },
      toggleCommentForm () {
        this.showCommentForm = !this.showCommentForm
      },
      validaPropiedad (obj, propiedad) {
        if (
          obj.hasOwnProperty(propiedad) &&
          obj[propiedad] !== null &&
          obj[propiedad] !== undefined &&
          obj[propiedad] !== ''
        ) {
          return obj[propiedad]
        }
        return null
      },
      async enviarMarcacion () {
        if (!this.puedeEnviar) {
          // alert('Por favor completa todos los campos antes de registrar la marcación')
          Mensajes.warning('Aviso', 'Por favor completa todos los campos antes de registrar la marcación.')
          return
        }

        try {
          this.form.validateFields(async (err, values) => {
            if (!err) {
              const response = await this.httpClient.getInstance().post('marcaciones_geo/store', {
                imagen: this.fotoBase64,
                tipo: this.tipo,
                latitud: this.latitud,
                longitud: this.longitud,
                fecha: this.fecha,
                hora: this.hora,
                observation: this.observation,
                comment: this.comment,
                license_plate_or_project: this.validaPropiedad(values, 'license_plate_or_project'),
                place_of_departure: this.validaPropiedad(values, 'place_of_departure'),
                initial_mileage: this.validaPropiedad(values, 'initial_mileage'),
                description_route: this.validaPropiedad(values, 'description_route'),
                description_route2: this.validaPropiedad(values, 'description_route2'),
                description_route3: this.validaPropiedad(values, 'description_route3'),
                description_route4: this.validaPropiedad(values, 'description_route4'),
                description_route5: this.validaPropiedad(values, 'description_route5'),
                description_route6: this.validaPropiedad(values, 'description_route6'),
                client_name: this.validaPropiedad(values, 'client_name'),
                make_another_tour: this.validaPropiedad(values, 'make_another_tour'),
                end_time: this.validaPropiedad(values, 'end_time'),
                final_mileage: this.validaPropiedad(values, 'final_mileage'),
                number_passengers: this.validaPropiedad(values, 'number_passengers'),
                break_time: this.validaPropiedad(values, 'break_time'),
                transport_user: this.validaPropiedad(values, 'transport_user')
              })

              if (response.status === 200) {
                // alert('Marcación registrada exitosamente')
                Mensajes.success('¡Marcación exitosa!', 'Tu marcación ha sido registrada correctamente')
                this.$emit('cerrar')
              }
            }
          })
        } catch (error) {
          Mensajes.error('Error', 'No fue posible registrar la marcación. Intenta nuevamente.')
        }
      },
      cerrar () {
        this.$emit('cerrar')
      },
      digitsOnly (value) {
        const s = value == null ? '' : String(value)
        return s.replace(/\D/g, '')
      },
      validatePositiveNumber (rule, value, callback) {
        if (value !== null && value !== undefined && value !== '') {
          if (value <= 0) {
            callback(new Error('El valor debe ser mayor a cero'))
          } else if (value < 0) {
            callback(new Error('No se permiten valores negativos'))
          } else {
            callback()
          }
        } else {
          callback()
        }
      },
      validateKilometraje (rule, value, callback) {
        if (value !== null && value !== undefined && value !== '') {
          if (value <= 0) {
            callback(new Error('El valor debe ser mayor a cero'))
          } else if (value < 0) {
            callback(new Error('No se permiten valores negativos'))
          } else if (value > 999999) {
            callback(new Error('El kilometraje no puede superar 6 dígitos (999999)'))
          } else {
            callback()
          }
        } else {
          callback()
        }
      }
    },
    computed: {
      /*      puedeEnviar () {
              return this.fotoTomada && this.tipo && this.latitud && this.longitud
            } */
      puedeEnviar () {
        return (!this.cargandoMarcaciones &&
          this.fotoTomada &&
          this.tipo &&
          this.latitud &&
          this.longitud &&
          this.cantidadMarcacionesHoy < 4)
      }
    }
  }
</script>

<style scoped>
  .modal {
    position: fixed;
    background: rgba(0, 0, 0, 0.5);
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 100;
    padding: 16px; /* Agregado para evitar que el contenido toque los bordes */
    overflow-y: auto; /* Permite hacer scroll en pantallas pequeñas */
  }

  .modal-content {
    background: #fff;
    padding: 15px;
    width: 100%;
    max-width: 500px;
    max-height: 90vh; /* Limita la altura total al 95% de la pantalla */
    overflow-y: auto; /* Scroll solo dentro del contenido si se necesita */
    border-radius: 5px;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.25);
    font-family: 'Segoe UI', sans-serif;
    animation: popIn 0.3s ease-out;
  }

  @keyframes popIn {
    0% {
      transform: scale(0.95);
      opacity: 0;
    }
    100% {
      transform: scale(1);
      opacity: 1;
    }
  }

  h2 {
    text-align: center;
    margin-bottom: 8px;
    color: #333;
  }

  .descripcion {
    font-size: 13px;
    text-align: center;
    margin-bottom: 10px;
    color: #666;
  }

  .preview video,
  .preview img {
    width: 70%;
    height: 60%;
    border-radius: 12px;
    /*box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);*/
    margin-bottom: 12px;
    background: #000;
    /*min-height: 50px;*/
    text-align: center;
    display: block; /* Asegura que se trate como bloque */
    margin-left: auto; /* Centra horizontalmente */
    margin-right: auto; /* Centra horizontalmente */
  }

  button {
    display: block;
    width: 100%;
    margin: 8px 0;
    padding: 2px;
    font-weight: 600;
    border: none;
    border-radius: 8px;
    background-color: #eeeeee;
    color: #333;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
  }

  button:hover {
    background-color: #dcdcdc;
  }

  button.activo {
    background-color: #28a745;
    color: white;
    box-shadow: 0 0 0 2px #c3e6cb;
  }

  button:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }

  .btn-registrar {
    background-color: #28a745;
    color: white;
    font-weight: bold;
  }

  .btn-registrar:hover {
    background-color: #218838;
  }

  button:last-of-type {
    margin-bottom: 4px;
  }

  p {
    margin: 6px 0;
    color: #555;
    font-size: 14px;
  }

  .boton-foto {
    display: flex;
    justify-content: center;
    margin-top: -15px;
    margin-bottom: 12px;
  }

  /* Aplica al botón dentro del contenedor */
  .boton-foto button {
    width: 70%;
  }

  .tipo-botones {
    display: flex;
    justify-content: space-between;
    gap: 12px;
    margin-top: -10px;
    margin-bottom: 8px;
  }

  .tipo-botones button {
    width: 100%;
  }

  .comment-form {
    margin-top: 10px;
  }

  .comment-form label {
    display: block;
    margin-bottom: 5px;
    font-weight: bold;
  }

  .comment-form input,
  .comment-form textarea {
    width: 100%;
    margin-bottom: 10px;
    padding: 5px;
    border-radius: 4px;
    border: 1px solid #ccc;
  }
</style>





// WEBPACK FOOTER //
// src/customization/SelfService/pages/Dashboard/MarcacionGeo.vue